import { getMediaDimensions } from 'utils/helpers'

export const PLACEMENT_RATIO_THRESHOLD = 1.4

export const getPlacementTypeFromDimensions = ({ width, height }) => {
  if (!width || !height) return null
  return height / width > PLACEMENT_RATIO_THRESHOLD ? 'reel' : 'feed'
}

export const getPlacementTypeFromMedia = (media) => {
  if (!media) return null
  if (media.placement_type) return media.placement_type
  return getPlacementTypeFromDimensions(media)
}

export const getPlacementTypeFromFile = async (file) => {
  if (!file) return null
  const dimensions = await getMediaDimensions(file)
  return getPlacementTypeFromDimensions(dimensions)
}

/** Required type from other cards; exclude current card so sole-card replace can switch feed/reel. */
export const getCarouselRequiredPlacementType = (cards = [], { excludeCardId } = {}) => {
  const existingWithMedia = cards.filter(
    (card) => card.media?.url && card.id !== excludeCardId,
  )
  if (!existingWithMedia.length) return null

  return getPlacementTypeFromMedia(existingWithMedia[0].media)
}

export const getCarouselPlacementUploadErrorKey = (incomingType, requiredType) => {
  if (!incomingType || !requiredType || incomingType === requiredType) return null
  return incomingType === 'reel' ? 'reel' : 'feed'
}

export const validateCarouselPlacementConsistency = (cards = []) => {
  const types = cards
    .filter((card) => card.media?.url)
    .map((card) => getPlacementTypeFromMedia(card.media))
    .filter(Boolean)

  if (types.length <= 1) return null

  const uniqueTypes = new Set(types)
  if (uniqueTypes.size > 1) {
    return 'Recommendations.campaign.setup.carouselAd.errors.mixedPlacement'
  }

  return null
}
